import styles from './styles.module.scss';

import { Paper } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body1 } from '@work4all/components/lib/typography/body1/Body1';
import { Body2 } from '@work4all/components/lib/typography/body2/Body2';

export const NoAdminRightsBanderole: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Paper className={styles.root}>
      <Body2 className={styles.body2}>{t('MASK.EDITING_NOT_POSSIBLE')}</Body2>
      <span className={styles.seperator} />
      <Body1>{t('MASK.CONTACT_YOUR_ADMIN')}</Body1>
    </Paper>
  );
};
